export default "__VITE_ASSET__f8d27141__"